import { PROTOTYPE_MOBILE_PREFIX } from "../../mobileRoutePrefix";

/** App Store animation capture — isolated from static screenshot scenes 01–10. */
export const SLIDING_ANIMATION_TITLE = "Sliding Puzzle Quest — Animation";

export const ANIMATION_MAIN_PATH = `${PROTOTYPE_MOBILE_PREFIX}/sliding/animation`;

export const ANIMATION_SCENE_PATH = `${ANIMATION_MAIN_PATH}/:slug`;

export const ANIMATION_VIDEO_PATH = `${ANIMATION_MAIN_PATH}/:slug/video`;

export const ANIMATION_BRAND_PATH = `${ANIMATION_MAIN_PATH}/:slug/brand`;

export function animationPath(slug) {
    return `${ANIMATION_MAIN_PATH}/${slug}`;
}

export function animationVideoPath(slug) {
    return `${ANIMATION_MAIN_PATH}/${slug}/video`;
}

export function animationBrandPath(slug) {
    return `${ANIMATION_MAIN_PATH}/${slug}/brand`;
}
